<!-- <app-pagetitle title="{{'Danh sách cửa hàng' | translate}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->

<div class="card">
    <div class="card-body">
        <h5>{{ "Danh sách giao dịch gia hạn" | translate }}</h5>
        <div class="row">
            <div class="flex-fill row">
                <div class="col-3">
                    <div class="form-group">
                        <label for="validationCustom01">{{
                            "Số điện thoại" | translate
                            }}</label>
                        <input type="text" class="form-control" [(ngModel)]="filter.phone"
                            placeholder="{{ 'Nhập số điện thoại' | translate }}" />
                    </div>
                </div>
                <div class="col-3">
                    <div class="form-group">
                        <label for="validationCustom01">{{
                            "Số tài khoản" | translate
                            }}</label>
                        <input type="text" class="form-control" [(ngModel)]="filter.terminal_bank_acc"
                            placeholder="{{ 'Nhập số tài khoản' | translate }}" />
                    </div>
                </div>
                <div class="form-group col-3">
                    <label for="validationCustom01">{{
                        "Chọn loại thiết bị" | translate
                        }}</label>
                    <ng-select [(ngModel)]="filter.device_type_name" (change)="submitFilter()">
                        <!-- <ng-option value="" [disabled]="true" hidden>
                              {{ 'Trạng thái' | translate }}
                          </ng-option> -->
                        <ng-option value="">Tất cả</ng-option>
                        <ng-option value="Loa 4G">Loa 4G</ng-option>
                        <ng-option value="Loa Wifi">Loa Wifi</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col-3">
                    <label for="validationCustom01">{{
                        "Chọn gói gia hạn" | translate
                        }}</label>
                    <ng-select [(ngModel)]="filter.original_duration" (change)="submitFilter()">
                        <!-- <ng-option value="" [disabled]="true" hidden>
                              {{ 'Trạng thái' | translate }}
                          </ng-option> -->
                        <ng-option value="">Tất cả</ng-option>
                        <ng-option value="3">Gói 3 tháng</ng-option>
                        <ng-option value="6">Gói 6 tháng</ng-option>
                        <ng-option value="12">Gói 12 tháng</ng-option>
                    </ng-select>
                </div>
                <div class="form-group col-3">
            <mat-form-field appearance="fill" class="mt-3">
              <mat-label>Chọn khoảng ngày tạo </mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input
                  matStartDate
                  formControlName="start"
                  placeholder="Ngày bắt đầu"
                />
                <input
                  matEndDate
                  formControlName="end"
                  placeholder="Ngày kết thúc"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
              <mat-error
                *ngIf="range.controls.start.hasError('matStartDateInvalid')"
                >Invalid start date</mat-error
              >
              <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')"
                >Invalid end date</mat-error
              >
            </mat-form-field>
          </div>

                <div class="col-3">
                    <div style="min-width: 200px; padding-left: 15px">
                        <div class="form-group">
                            <label for="validationCustom01" class="d-block">&nbsp;</label>
                            <button class="btn btn-primary btnall" (click)="submitFilter()">
                                {{ "PAGE.REPORT.Search" | translate }}
                            </button>
                            <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">
                                {{ "FORM.Clear" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <h6 class="col-3">Tổng số giao dịch: <span class="blue">{{ totalCount }}</span></h6>
            <!-- <button class="btn btn-success mb-2" (click)="openModal(content)">
                <i class="mdi mdi-plus mr-2"></i>
                {{ "Tạo lô Terminal và QR" | translate }}
            </button> -->
            <!-- <button class="btn btn-info mb-2" (click)="openModalLink(contentLink)">
                  <i class="mdi mdi-plus mr-2"></i> {{'Liên kết' | translate}}
              </button> -->
        </div>
        <div class="row mb-md-2"></div>
        <div class="table-responsive">
            <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr class="text-center bg-table">
                        <th>{{ "#" | translate }}</th>
                        <th>{{ "Loại thiết bị" | translate }}</th>
                        <th>{{ "Tên cửa hàng" | translate }}</th>
                        <th>{{ "Số tài khoản" | translate }}</th>
                        <th>{{ "Số điện thoại" | translate }}</th>
                        <th>{{ "Gói gia hạn" | translate }}</th>
                        <th>{{ "Tháng tặng thêm" | translate }}</th>
                        <th>{{ "Số tiền" | translate }}</th>
                        <th>{{ "Ngày gia hạn" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" *ngFor="let data of listData; let i = index">
                        <td>
                            <a>{{ pageSize * (pageIndex - 1) + i + 1 }}</a>
                        </td>
                        <td>
                            <a>{{ data.device_type_name }}</a>
                        </td>
                        <td>
                            <a>{{ data.workspace_name }}</a>
                        </td>
                        <td>
                            <a>{{ data.terminal_bank_acc }}</a>
                        </td>
                        <td>
                            <a>{{ data.phone }}</a>
                        </td>
                        <td>
                            <a>{{ data.original_duration }} tháng</a>
                        </td>
                        <td>
                            <a>{{ data.duration - data.original_duration }} tháng</a>
                        </td>
                        <td>
                            <a>{{ data.discounted_price.toLocaleString('vi-VN') }} VNĐ</a>
                        </td>
                        <td>
                            {{ data.created_at | date : "dd/MM/yyyy HH:mm" }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-2">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{ "TABLE.Showing" | translate }}
                    {{ pageSize * pageIndex - pageSize + 1 }}
                    {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
                    {{ "TABLE.of" | translate }} {{ totalCount }}
                    {{ "TABLE.entries" | translate }}
                </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end">
                <div class="text-md-right float-md-right pagination-rounded">
                    <ngb-pagination [collectionSize]="totalCount" [(page)]="pageIndex" [pageSize]="pageSize"
                        [maxSize]="5" [ellipses]="true" (pageChange)="fetchData()">
                    </ngb-pagination>
                </div>
                <div class="dataTables_length ml-3" id="tickets-table_length">
                    <label class="d-inline-flex align-items-center mb-0">
                        {{ "TABLE.Show" | translate }}
                        <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                            [(ngModel)]="pageSize" (ngModelChange)="pageIndex = 1; fetchData()"
                            class="custom-select custom-select-sm form-control form-control-sm mx-2">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="25">25</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                        </select>
                        {{ "TABLE.entries" | translate }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #content role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">
            {{
            formData.value.id ? "FORM.Edit" : ("Tạo lô Terminal và QR" | translate)
            }}
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="saveData()" [formGroup]="formData">
                <div class="row">
                    <div class="form-group row col-md-12">
                        <div class="col mt-3">
                            <label for="quantity">{{ "Số lượng" | translate }}</label>
                            <input type="number" id="quantity" class="form-control" formControlName="quantity" min="1"
                                required />
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px"
                        (click)="modal('close click')">
                        {{ "Đóng" | translate }}
                    </button>
                    <button type="submit" class="btn btn-success btn-lg" style="width: 150px">
                        {{ "Tạo" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">
            {{ "Liên kết thiết bị và tài khoản" | translate }}
        </h5>
        <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
              Mật khẩu không được bỏ trống.
          </div> -->
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form (ngSubmit)="saveData2()" [formGroup]="formData2">
                <div class="row">
                    <div class="form-group row col-md-12">
                        <div class="col mt-3">
                            <div class="d-flex">
                                <label class="col-md-4 col-form-label required_label">{{
                                    "Thiết bị" | translate
                                    }}</label>
                                <div class="col-md-8">
                                    <ng-select formControlName="device_id">
                                        <ng-option [value]="-1">Chọn thiết bị</ng-option>
                                        <ng-option [value]="item.device_id" *ngFor="let item of listData2">
                                            {{ item.serial_number }}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row col-md-12">
                        <div class="col mt-3">
                            <div class="d-flex">
                                <label class="col-md-4 col-form-label required_label">{{
                                    "Tài khoản" | translate
                                    }}</label>
                                <div class="col-md-8">
                                    <ng-select formControlName="bankaccount_id">
                                        <ng-option [value]="-1">Chọn tài khoản</ng-option>
                                        <ng-option [value]="item.bankaccount_id" *ngFor="let item of listData3">
                                            {{ item.account_number }} - {{ item.bank_account_name }} -
                                            {{ item.bank_name }}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="text-right">
                      <button type="button" class="btn btn-secondary btn-sm mr-3"
                          (click)="modal('close click')">{{'Đóng' | translate}}</button>
                      <button type="submit" class="btn btn-primary btn-sm">{{'Lưu' | translate}}</button>
                  </div> -->
                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px"
                        (click)="modal('close click')">
                        {{ "Đóng" | translate }}
                    </button>
                    <button type="submit" class="btn btn-success btn-lg" style="width: 150px">
                        {{ "Lưu" | translate }}
                    </button>
                    <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                      (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                  <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                      (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
    <div class="modal-header">
        <h5 class="modal-title">List keyword of "{{ selectedIncident.name }}"</h5>
        <button type="button" class="close" aria-label="Close" (click)="modalHis('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="mb-3" *ngIf="formNewKeyword">
            <h5 class="font-size-14">Add New Keyword</h5>
            <form [formGroup]="formNewKeyword" (submit)="onSubmitFormKeyword(2)" class="d-flex">
                <input type="text" class="form-control form-control-sm" style="width: 250px" formControlName="name" />
                <button class="btn btn-primary btn-sm ml-3" style="width: 150px">
                    Add
                </button>
            </form>
        </div>
        <div class="table-responsive">
            <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr>
                        <th width="50">#</th>
                        <th>Name</th>
                        <!-- <th>Thời gian</th> -->
                        <th width="170"></th>
                    </tr>
                </thead>
                <tbody *ngFor="let data of dataKeyword; let i = index">
                    <tr>
                        <td>{{ i + 1 }}</td>
                        <td>
                            <ng-container *ngIf="
                    selectedKeyword?.id == data.id && formEditKeyword;
                    else normal
                  ">
                                <form [formGroup]="formEditKeyword" (submit)="onSubmitFormKeyword(1)">
                                    <input type="text" class="form-control form-control-sm" formControlName="name" />
                                </form>
                            </ng-container>
                            <ng-template #normal>{{ data.name }}</ng-template>
                        </td>
                        <!-- <td>{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
                        <td>
                            <div class="d-flex" style="gap: 10px">
                                <a class="btn btn-sm btn-success" href="javascript: void(0);"
                                    (click)="editKeyword(data, i)">
                                    <i class="mdi mdi-account-edit"></i>{{ "FORM.Edit" | translate }}</a>
                                <a class="text-white btn btn-sm btn-danger" (click)="onDeleteKeyword(data.id)"><i
                                        class="mdi mdi-delete"></i>{{ "FORM.Delete" | translate }}</a>
                            </div>
                            <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                              <button>Xoá</button> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>

<ng-template #contentQR role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">Hiển thị QR</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form [formGroup]="formData">
                <div class="row">
                    <!-- <div class="form-group row col-md-12">
              <label class="col-md-2 col-form-label required_label">{{
                "Serial" | translate
              }}</label>
              <div class="col-md-10">
                <input
                  disabled
                  type="text"
                  class="form-control"
                  formControlName="serial_number"
                  [ngClass]="{
                    'is-invalid': submitted && form.serial_number.errors
                  }"
                />
              </div>
            </div> -->
                    <div class="form-group row col-md-12">
                        <div class="col-md-12 d-block justify-content-center">
                            <div class="d-flex justify-content-center">
                                <div class="borderQR d-flex flex-column align-items-center" *ngIf="flagDownQr"
                                    #qrContainer>
                                    <div class="qr-with-text canvas-container">
                                        <qr-code class="custom-qr-code" [value]="qrCodeValue" [size]="400"
                                            [errorCorrectionLevel]="'M'">
                                        </qr-code>
                                        <!-- <div class="text-center user-info" *ngIf="flagDownQr">
                        <h3 class="font-weight-bold">
                          {{ data.terminal_bank_acc_name }}
                        </h3>
                        <h3 class="font-weight-bold">
                          {{ data.terminal_bank_acc }}
                        </h3>
                      </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <div class="col-12 col-md-3 p-0">
                                    <button class="btn-viettel col" (click)="downloadQRCode()">
                                        <span class="m-auto">Tải xuống mã QR</span>
                                    </button>
                                    <button class="btn-viettel col mt-2" (click)="printQRCode()">
                                        In QR Code
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px"
                        (click)="modal('close click')">
                        {{ "Đóng" | translate }}
                    </button>
                    <!-- <button
              type="submit"
              class="btn btn-success btn-lg"
              style="width: 150px;"
            >
              {{'Lưu' | translate}}
            </button> -->
                    <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                          (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                      <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                          (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
                </div>
            </form>
        </div>
    </div>
</ng-template>